import BaseComponentController from "./base_component_controller"
import Toastify from "toastify-js"

export default class extends BaseComponentController {
  static values = {
    type: { type: String, default: '' },
    typeClasses: { type: Object, default: {} },
    autoShow: { type: Boolean, default: true },
    options: { type: Object, default: {} }
  }

  connect() {
    if (this.autoShowValue) {
      this.show()
    }
  }

  show(event) {
    event?.preventDefault()

    Toastify({
      ...this.defaultOptions,
      ...{ className: this.typeClassesValue[this.typeValue] },
      ...this.optionsValue
    }).showToast()
  }

  get defaultOptions() {
    return {
      close: true,
      stopOnFocus: true,
      gravity: 'bottom',
      position: 'center',
      escapeMarkup: false,
      duration: 2000,
      onClick: () => {
        this.dispatchEvent({ action: 'clicked' })
      }
    }
  }
}
